/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locationWebsiteId, locationWebsite) => ({
    type: actions.EDIT_LOCATION_WEBSITE,
    payload: {
        id: locationWebsiteId,
        locationWebsite,
    },
});